let initialState = {
  showMoreSection: null,
  editPanelInfo: null,
  widgetEditInfo: null,
  sectionOffset: null,
  shareableData: { id: null, link: null, isShared: false },
  scrollViewRef: null,
  widgetArray: [],
  widgetDiv: [],
  chart_flag: false,
  visited_widget_id: null,
  global_selected_widget_id: null,
  // realtimeFiltersObj: {
  //   pagination: { current_page: 1 },
  //   user_name: { filterArray: [], visible: false },
  //   current_status: { filterArray: [], visible: false },
  //   status_duration: { filterArray: [], visible: false },
  //   tickets_in_queue: { filterArray: [], visible: false },
  //   unactioned_queue: { filterArray: [], visible: false },
  //   oldest_ticket_since: {
  //     filterArray: [],
  //     visible: false,
  //     inputVal: 0,
  //     selectedVal: "days",
  //   },
  // },
  realtimeFiltersObj: {},

  // realtimeFinalFilters: {
  //   user_name: { value: false },
  //   current_status: { value: false },
  //   status_duration: { value: false },
  //   tickets_in_queue: { value: false },
  //   unactioned_queue: { value: false },
  //   oldest_ticket_since: { value: false },
  // },
  realtimeFinalFilters: {},
  isTextWidgetPopupVisible: false,
  textWidgetObj: {
    section_id: null,
    widget_id: null,
    widget_name: null,
    widget_text_data: null,
  },
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case "SHOW_MORE_SECTION":
      return {
        ...state,
        showMoreSection: action.payload,
      };

    case "SET_ON_EDIT_PANEL":
      return {
        ...state,
        editPanelInfo: action.payload,
      };

    case "SET_ON_WIDGET_EDIT":
      return {
        ...state,
        widgetEditInfo: action.payload,
      };
    case "SET_SECTION_OFFSET":
      return {
        ...state,
        sectionOffset: action.payload,
      };
    case "SET_SHAREABLE_DATA":
      return {
        ...state,
        shareableData: action.payload,
      };
    case "SET_SCROLL_VIEW":
      return {
        ...state,
        scrollViewRef: action.payload,
      };
    case "SET_WIDGET_ARRAY":
      return {
        ...state,
        widgetArray: action.payload,
      };
    case "SET_WIDGET_DIV":
      return {
        ...state,
        widgetDiv: action.payload,
      };
    case "SET_CHART_FLAG":
      return {
        ...state,
        chart_flag: action.payload,
      };
    case "SET_VISITED_WIDGET_ID":
      return {
        ...state,
        visited_widget_id: action.payload,
      };
    case "SET_GLOBAL_SELECTED_WIDGET_ID":
      return {
        ...state,
        global_selected_widget_id: action.payload,
      };
    case "SET_REALTIME_FILTER_OBJ":
      return {
        ...state,
        realtimeFiltersObj: action.payload,
      };
    case "SET_REALTIME_FINAL_FILTERS":
      return {
        ...state,
        realtimeFinalFilters: action.payload,
      };
    case "SET_TEXT_WIDGET_POPUP_VISIBLE":
      return {
        ...state,
        isTextWidgetPopupVisible: action.payload,
      };
    case "SET_TEXT_WIDGET_OBJECT":
      return {
        ...state,
        textWidgetObj: action.payload,
      };
    default:
      return state;
  }
};

export default dashboard;
